import React from "react";
import AdPoliciesPage from "./ad-policies/AdPoliciesPage";
import DbPoliciesPage from "./db-policies/DbPoliciesPage";
import RadiusPoliciesPage from "./radius-policies/RadiusPoliciesPage";
import SshPoliciesPage from "./ssh-policies/SshPoliciesPage";

// /pam/policy/v2 is shared by every MFA mode; render the list that matches the
// mode the tenant is in — PAM (SSH), database, RADIUS, or AD (the default).
export default function PoliciesIndex() {
  const currentMode = localStorage.getItem("currentMode");
  // PAM used to fall through to the AD list here.
  if (currentMode === "mfa_pam" || currentMode === "pam") return <SshPoliciesPage />;
  if (currentMode === "mfa_db") return <DbPoliciesPage />;
  if (currentMode === "mfa_radius") return <RadiusPoliciesPage />;
  return <AdPoliciesPage />;
}
